import template from './building-management-company.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.buildingManagementCompany', [])
    .directive('cianAfAboutBuildingBuildingManagementCompany', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.validation = validation(this.form, 'building.managementCompany', {

            });
        }],
        controllerAs: 'buildingManagementCompany',
        template,
    }))
    .name;
